import styled, { css } from 'styled-components'
import { BREAK_POINT_LG } from '@CSSVars/variables'
import {
  OUTLINE_COLOR,
  GREY_BACKGROUND,
  CLICKABLE_COLOR_LIGHT,
} from '@CSSVars/colors'

const HEIGHT = '36px'


const fullPageCss = css`
  width: calc(100% - 32px);
  position: fixed;
  top: auto !important;
  left: 16px;
  bottom: 16px;
  padding: 0 !important;
  border-radius: 10px;
  border: 1px solid white;
  > div {
    line-height: 40px;
    margin: 20px 0;
    padding: 0;
    border: none;
    font-weight: 600;
  }
`


export const _AppDropdown = styled.div.attrs(props => ({
  className: props.fullPage ? 'appDropdownFullPage' : 'appDropdown',
}))`
  width: 100%;
  min-width: 140px;
  position: relative;

  > div {
    height: ${HEIGHT};
    padding: 10px 36px 10px 12px;

  }
  svg {
    top: 50% !important;
  }
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    margin-bottom: 12px;

    .dropdownCont:has(div) {
      &:before {
        content: " ";
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0,0,0,.5);
        z-index: 9999;
      }
    }
  }

  @media screen and (max-width: 374px) {
    width: 100%;
    min-width: 120px;
  }
  .dropdown {
    top: ${HEIGHT} !important;
    padding: 0 !important;
    max-height: 300px;
    max-width: 343px;

    overflow-y: scroll;
    @media screen and (max-width: ${BREAK_POINT_LG}) {
      ${({ fullPage }) => (fullPage ? fullPageCss : '')}
      ${({ isMobileApp, fullPage }) => (isMobileApp && fullPage ? 'bottom:  90px' : '') };

      left: 50% !important;
      transform: translateX(-50%);
    }

  }
  .dropdownTitle {
    width: 100%;
    text-align: left;
    white-space: nowrap;
  }

`


export const _Item = styled.div`
  white-space: nowrap;
  line-height: 22px;
  padding: 6px 12px;
  border-bottom: 1px solid ${OUTLINE_COLOR};

  color: ${({ active }) => (active ? CLICKABLE_COLOR_LIGHT : 'inherit')};
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background: ${GREY_BACKGROUND};
  }
   &:focus {
    background: ${GREY_BACKGROUND};
  }
`
